//设置一级产品分类
import {getToken} from "../utils/auth"
import cal from '../utils/calculation'
import fix from '../utils/fixed'

export const SET_TOP_CATEGORIES = (state, data) => {
  state.topCategories = data;
}

export const SET_ALL_MAIN_CATEGORIES = (state, data) => {
  state.allMainCategories = data;
}

export const SET_HOME_ADS = (state, data) => {
  state.marketing = data
}

export const SET_SHOW_FILTER_MORE = (state, data) => {
  state.showFilterMore = data
}

//设置token及login用户信息
export const SET_TOKEN = (state, data) => {
  state.token = data.token;
  state.loginUserInfo=data
}

// 设置注册步骤
export const SET_SIGN_UP_SETP = (state, step) => {
  state.signUpStep = step;
};

// 设置用户登录信息
export const SET_USER_LOGIN_INFO = (state, data) => {
  state.userInfo = data;
};

// 设置加载状态
export const SET_LOAD_STATUS = (state, status) => {
  state.isLoading = status;
};

// 设置秒杀商品
export const SET_SECKILLS_INFO = (state, seckills) => {
  state.seckills.goodsList = seckills[0];
  state.seckills.deadline = seckills[1];
};

// 设置轮播(营销)图
export const SET_CAROUSELITEMS_INFO = (state, { carouselItems, activity }) => {
  state.marketing.CarouselItems = carouselItems;
  state.marketing.activity = activity;
};

// 设置电脑专栏数据
export const SET_COMPUTER_INFO = (state, computer) => {
  state.computer = computer;
};

// 设置爱吃专栏数据
export const SET_EAT_INFO = (state, eat) => {
  state.eat = eat;
};

// 减少秒杀时间
export const REDUCE_SECKILLS_TIME = state => {
  state.seckills.deadline.seconds--;
  if (state.seckills.deadline.seconds === -1) {
    state.seckills.deadline.seconds = 59;
    state.seckills.deadline.minute--;
    if (state.seckills.deadline.minute === -1) {
      state.seckills.deadline.minute = 59;
      state.seckills.deadline.hour--;
    }
  }
};

// 设置商品列表(搜索)
export const SET_GOODS_LIST = (state, data) => {
  state.goodsList = data.goodsList;
  state.asItems = data.asItems;
};

// 设置商品列表排序
export const SET_GOODS_ORDER_BY = (state, data) => {
  state.orderBy = data;
};

// 设置商品详细信息
export const SET_GOODS_INFO = (state, data) => {
  state.goodsInfo = data;
};

// 添加购物车
export const ADD_SHOPPING_CART = (state, data) => {
  let item=JSON.parse(JSON.stringify(data))
  // let idx = item.orderUnits.findIndex(v => v.orderUnit === item.orderUnit)
  // if( item.orderAmount === item.minOrderQuantity) {
  //   if(item.productAttribute === 2) {
  //     if(item.orderUnits[idx].rate ===1) {
  //       if (item.minOrderQuantity / item.chargeQty > Math.floor(item.minOrderQuantity / item.chargeQty)) {
  //         item.orderAmount = (Math.floor(item.minOrderQuantity / item.chargeQty) + 1) * item.chargeQty
  //       } else {
  //         item.orderAmount = (Math.floor(item.minOrderQuantity / item.chargeQty)) * item.chargeQty
  //       }
  //     }
  //   } else {
  //       if (item.minOrderQuantity / item.chargeQty > Math.floor(item.minOrderQuantity / item.orderUnits[idx].rate)) {
  //         item.orderAmount = Math.floor(item.minOrderQuantity /  item.orderUnits[idx].rate) + 1
  //       } else {
  //         item.orderAmount = Math.floor(item.minOrderQuantity / item.orderUnits[idx].rate) 
  //       }
  //       item.orderAmount = (Math.floor(item.minOrderQuantity / item.chargeQty) + 1) * Math.floor(item.chargeQty / item.orderUnits[index].rate)
  //   }
  // }
  item.productSkuName=item.productSkuName||item.skuName||item.productName
  item.salesPrice=item.price||item.salesPrice
  item.productSkuId=item.skuId||item.productSkuId
  item.skuImage=item.pic||item.skuImage||(item.skuImages?item.skuImages[0]:'')
  let a=state.shoppingCart.findIndex(it=>{
    return it.productSkuId==item.productSkuId
  })
  let totalNum = 0
  if(a==-1){
    state.shoppingCart.push(item);
  } else{
    // state.shoppingCart[a].orderAmount += item.orderAmount
    state.shoppingCart[a].orderAmount = cal.accAdd(item.orderAmount , state.shoppingCart[a].orderAmount) 
  }
  state.newShoppingCart = item;
  let b = fix.fixed(item.salesPrice * item.orderAmount)
  state.totalPrice=cal.accAdd(Number(b),state.totalPrice) 
};

// 设置购物车信息
export const SET_SHOPPING_CART = (state, data) => {
  state.shoppingCart = data;
  state.totalPrice=0
  state.shoppingCart.map(item=>{
    if(item.salesPrice){
      let a = fix.fixed(item.salesPrice * item.orderAmount)
      state.totalPrice=cal.accAdd(Number(a),state.totalPrice) 
    }
  })
};
// 删除购物车商品
export const DEL_SHOPPING_CART = (state, data) => {
  state.shoppingCart.map((item,index)=>{
    if(item.productSkuId==data.productSkuId){
      state.shoppingCart.splice(index,1)
      // let a = (this.$cal.accMul(item.salesPrice, item.orderAmount)).toFixed(2)
      let a = fix.fixed(item.salesPrice * item.orderAmount)
      // state.totalPrice-= Number(a)
      state.totalPrice = cal.accSub(state.totalPrice,Number(a))
    }
  })
};

// 设置推荐信息
export const SET_RECOMMEND_INFO = (state, data) => {
  state.recommend = data;
};

// 设置收获地址
export const SET_USER_ADDRESS = (state, data) => {
  state.address = data;
};

// 展现登陆弹窗
export const SHOW_LOGIN_BOX = (state) => {
  state.showLogin = true;
};

// 关闭登陆弹窗
export const CLOSE_LOGIN_BOX = (state) => {
  state.showLogin = false;
};
// 开启加载中动画
export const SHOW_LOADING = (state) => {
  state.showLoading = true;
};
// 开启加载中动画
export const CLOSE_LOADING = (state) => {
  state.showLoading = false;
};
// 购物车选中商品加入订单列表
export const SET_ORDERLIST = (state,data) => {
  state.orderComList = data;
  state.orderComList.map(item=>{
    item.price=item.salesPrice
    item.unit=item.chargeUnit
  })
};
// 提交订单清空订单列表以及购物车中已选中提交的商品
export const CLEAR_ORDERLIST = (state) => {
  for(let i=0;i<state.shoppingCart.length;i++){
    let a=state.orderComList.findIndex(item=>{
      return item.productSkuId==state.shoppingCart[i].productSkuId
    })
    if(a !== -1){
      state.shoppingCart.splice(i,1)
      i--
    }
  }
  state.orderComList = []
};
// 开启顶部广告
export const OPEN_HEAD_NEWS = (state) => {
  state.showNews=true
};
// 关闭顶部广告
export const CLOSE_HEAD_NEWS = (state) => {
  state.showNews=false
};

export const SET_PRODUCT_LIST = (state,data) => {
  state.productList=data
};
export const CHANGE_ERP = (state,data) => {
  state.isErp=data
};
export const CHANGE_PACK = (state,data) => {
  state.showPack=data
};
export const GET_CATEGORY = (state,data) => {
  state.category=data
};
export const SET_PHONE = (state,data) => {
  state.titlePhone=data
};
export const SET_HOMEBANNER = (state,data) => {
  state.HomeBanner=data
};
export const CHANGE_USERNAME = (state,data) => {
  state.username=data
};


// WEBPACK FOOTER //
// ./src/vuex/mutations.js